var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion-component" }, [
    _c(
      "div",
      { staticClass: "accordion-selectors", class: _vm.selectorBackground },
      [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "selector-container" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item",
                  class: { active: _vm.selectedIndex == index },
                  on: {
                    click: function($event) {
                      return _vm.expand(index)
                    }
                  }
                },
                [
                  _vm._t("accordion-selector-title", null, {
                    item: item,
                    itemIndex: index
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dot" })
                ],
                2
              )
            }),
            0
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "accordion-items" },
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            ref: "listItems",
            refInFor: true,
            staticClass: "item",
            class: [
              "background-" + (index % 3),
              { even: index % 2 == 0 },
              { odd: index % 2 != 0 }
            ]
          },
          [
            _c(
              "div",
              {
                staticClass: "header",
                on: {
                  click: function($event) {
                    return _vm.expand(index)
                  }
                }
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "header-title" },
                      [
                        _vm._t("accordion-item-header-title", null, {
                          item: item,
                          itemIndex: index
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._m(0, true)
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "contentItems",
                refInFor: true,
                staticClass: "accordion-content"
              },
              [
                _c(
                  "div",
                  { staticClass: "content-container" },
                  [
                    _vm._t("accordion-item-content", null, {
                      item: item,
                      itemIndex: index
                    })
                  ],
                  2
                )
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "collapse-toggle" }, [
      _c("span", { staticClass: "btn expand" }, [
        _vm._v("Expand "),
        _c("i", { staticClass: "fas fa-plus" })
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "btn collapse" }, [
        _vm._v("Collapse "),
        _c("i", { staticClass: "fas fa-minus" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }